import React, { useState } from "react";
import FooterPlayer from "./components/FooterPlayer";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "./Landing.css";
import UpcomingEvents from "./components/UpcomingEvents";
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
} from "@mui/material";

const Landing = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="landing-page">
      {/* Fixed Header */}
      <header className="site-header">
        <div className="header-container">
          <img
            src="/images/akwerius-banner-mini.jpg"
            alt="Akwerius Logo"
            className="header-logo"
            style={{ width: "50%", verticalAlign: "middle" }}
          />

          {/* Desktop Nav */}
          <nav className="header-nav desktop-nav">
            <a href="#home">Home</a>
            <a href="#upcoming">Tour</a>
            <a href="#channel">Channel</a>
            <a href="#album">Album</a>
            <a href="#bio">Bio</a>
            <a href="#connect">Connect</a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>

        {/* Mobile Nav */}
        {menuOpen && (
          <nav className="mobile-nav">
            <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
            <a href="#upcoming" onClick={() => setMenuOpen(false)}>Tour</a>
            <a href="#channel" onClick={() => setMenuOpen(false)}>Channel</a>
            <a href="#album" onClick={() => setMenuOpen(false)}>Album</a>
            <a href="#bio" onClick={() => setMenuOpen(false)}>Bio</a>
            <a href="#connect" onClick={() => setMenuOpen(false)}>Connect</a>
          </nav>
        )}
      </header>

      {/* Hero Section */}
      <header id="home" className="hero">
        <div className="overlay" />
        <div className="hero-content">
          <h1>Akwerius</h1>
          <p className="lead">Afro Roots Hop • Music Is Healing</p>
          <div className="hero-buttons">
            <a href="#album" className="btn btn-danger">Latest Release</a>
            <a href="#channel" className="btn btn-warning">Watch</a>
            <a
              href="http://musicishealing.us"
              target="_blank"
              rel="noreferrer"
              className="btn btn-success"
            >
              Shop MIHU
            </a>
          </div>
        </div>
      </header>

      <section id="upcoming">
        <UpcomingEvents />
      </section>

      {/* Channel Section */}
      <section id="channel" className="channel-section">
        <h1>
          <a
            href="https://www.youtube.com/channel/UCzFr7u6-hotJ32n1F9YG8zQ"
            target="_blank"
            rel="noreferrer"
          >
            CHANNEL
          </a>
        </h1>
        <div className="video-list">
          <iframe
            src="https://www.youtube.com/embed/26qwLqHgWno?si=CoennwtZPl-d6anl"
            title="Mr. Prezident"
            allowFullScreen
          />          
          <iframe
            src="https://player.vimeo.com/video/61911658?h=7a9a9b0be3"
            title="Born & Raised"
            allowFullScreen
          />     
          <iframe
            src="https://www.youtube.com/embed/7aQYTl7Lb8c?si=LWHmt6-EaB8WKBmI"
            title="Roots & Branches"
            allowFullScreen
          />               
        </div>
      </section>

      {/* Album Section */}
      <section id="album" className="album-section">
        <h1>
          <a
            href="https://aquarianproject.bandcamp.com/album/bright-side"
            target="_blank"
            rel="noreferrer"
          >
            OUT NOW!!
          </a>
        </h1>
        {/* <h3>BRIGHT SIDE</h3> */}
        <a
          href="https://aquarianproject.bandcamp.com/album/bright-side"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="https://wordsoundlife-berkeley-edu.apphost.ocf.berkeley.edu/images/BrightSide_Final.png"
            alt="Bright Side Album Cover"
            className="album-cover"
          />
        </a>
        <p>
          Published by <a href="http://musicishealing.us">Music Is Healing</a>
          <br />
          {/* Released: July 23, 2021 */}
        </p>
      </section>

      {/* ⭐ BIO SECTION ADDED HERE ⭐ */}
      <section id="bio" className="bio-section" style={{ display: "flex", flexDirection: "column", justifyContent: "center", width: "100%", padding: "0 1rem" }}>
    <Container maxWidth="lg" sx={{ py: 8 }}>

        <Box
          sx={{
            py: 8,
            color: "white",
            background: "transparent",
            backdropFilter: "blur(4px)",
            maxWidth: "1200px",
            width: "100%",
            mx: "auto",
          }}
        >
          <Grid
            container
            spacing={4}
          >
            {/* LEFT COLUMN – TEXT */}
            <Grid item xs={12} md={6}>
              {/* Image at the top */}
              <Box sx={{ mb: 3, textAlign: "center" }}>
                <Box
                  component="img"
                  src="/images/kwe-pic.jpg"
                  alt="Akwerius"
                  sx={{
                    width: "100%",
                    maxWidth: 400,
                    borderRadius: 2,
                    objectFit: "cover",
                  }}
                />
              </Box>
              <Box sx={{ width: "100%", maxWidth: 500, fontSize: "1.25rem", lineHeight: 1.7 }}>
                <p>
                  <strong>Akwerius</strong>, is a rising voice of the new millenium hailing out of West Africa bringing a unique sound dubbed Afro Roots Hop. Born Pierre-Valery Njenji Tchetgen to a Ghanaian mother and a Cameroonian father, kwe (as he is more commonly known) was raised between Cameroon, France and the United States. Though not born into a musical household, his passion for writing, singing and playing instruments was nurtured by the encouraging support of his family and his unwavering faith in the Almighty. His musical education began on the flute and piano, and later evolved to include poetry, percussion, guitar, melodica and saxophone. 
                </p>
                <p>
                  His lyrical commitment to devotion, social justice and the struggle against oppression was forged in personal experiences during his formative years that made him turn to the pen as a refuge and shield. This chapter of his journey is recounted in his first collection of poetry <i>Dirges of Becoming</i> released independently by Afro Roots Hop Press (2010), with the audio companion CD <a href="https://aquarianproject.bandcamp.com/album/dawn-soundtrack-to-dirges" target="blank" style={{ color: '#fbbf24' }}>Dawn</a>. 
                </p>
                <p>
                  As a poet, emcee, singer, deejay and producer, kwe draws inspiration from a plethora of pioneers of the Afro Beat, Roots Reggae and Hip Hop genres, namely Fela Kuti, Sade, Alpha Blondy, Bob Marley, Bunny Wailer, Culture, Burning Spear, Linton Kwesi Johnson, Arrested Development and KRS-ONE to name a few. His lyrical style - deep, raw and edgy - weaves potent spoken word with heart-felt chanting over entrancing dub riddims. 
                </p>
                <p>
                  On stage, Akwerius brings a transformative and deeply spiritual experience, blending acoustic dub poetry, devotional chanting, and Roots-driven riddims into a captivating live presence. Over the years, he has performed across the United States and internationally with configurations ranging from intimate acoustic sets to soundsystem and full-band ensembles such as <i>The Akwerian Project</i>. His live work includes appearances with artists such as Habib Koite, Mad Professor, KRS-ONE and musicians from the Music Is Healing collective, including collaborations with the New Awakening Band, the Jeff Robinson Trio, Sista Dee & the Dis-N-Dat Band, the Blake Newman Trio, Dub Station, Lionheart Sounds, Rally Up Music, FM Collective as well as performances in Ghana, Washington DC, Boston, Chicago, Oakland, and Mount Shasta. His festival and community performance highlights include Looptopia (2007), Reggae on the River (2008, 2016) and the Unity Through Music Grassroots Festival Celebration (2017–2022), a community arts programs presented by Word.Sound.Life. (a student-run organization he co-founded in Berkeley, CA), as well as numerous live-in-studio performances on media networks (Cameroon Radio Television, Cambridge Community TV, Boston Neighborhood Networks).
                </p>
                <p>
                  <strong>Selected Visuals:</strong><br />
                  <a href="https://www.youtube.com/watch?v=7aQYTl7Lb8c&list=RD7aQYTl7Lb8c&start_radio=1" target="_blank" rel="noreferrer" style={{ color: '#fbbf24' }}><strong>Roots & Branches</strong></a><br />
                  <a href="https://vimeo.com/61911658?fl=pl&fe=ti" target="_blank" rel="noreferrer" style={{ color: '#fbbf24' }}><strong>Born & Raised</strong></a><br />
                  <a href="https://www.youtube.com/watch?v=26qwLqHgWno&list=RD26qwLqHgWno&start_radio=1" target="_blank" rel="noreferrer" style={{ color: '#fbbf24' }}><strong>Mr. Prezident</strong></a><br />
                  {/* <a href="https://www.youtube.com/watch?v=E9vNdTDzRUQ&list=RDE9vNdTDzRUQ&start_radio=1" target="_blank" rel="noreferrer" style={{ color: '#fbbf24' }}><strong>Hail His Majesty</strong></a> */}
                </p>
              </Box>
            </Grid>

            {/* RIGHT COLUMN – IMAGE + TEXT */}
            <Grid
              item
              xs={12}
              md={6}
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* Right column text */}
              <Box sx={{ width: "100%", maxWidth: 500, fontSize: "1.25rem", lineHeight: 1.7 }}>
                <p>
                  "Sonrise" is his first independently released album, which features the video singles "<a href="https://www.youtube.com/watch?v=26qwLqHgWno&list=RD26qwLqHgWno&start_radio=1" target="_blank" rel="noreferrer"  style={{ color: '#fbbf24' }}>Mr. Prezident</a>", "<a href="https://www.youtube.com/watch?v=X1NcCVlZdI4&list=RDX1NcCVlZdI4&start_radio=1" target="_blank" rel="noreferrer"  style={{ color: '#fbbf24' }}>Babylon I'm Leaving</a>" and "<a href="https://www.youtube.com/watch?v=2LusBvTuRp4&list=RD2LusBvTuRp4&start_radio=1" target="_blank" rel="noreferrer"  style={{ color: '#fbbf24' }}>Sonrise</a>". Originally released in 2001 in Boston, this album is still finding renewed breath with a remastered version in the works.
                </p>
                <p>
                  In 2002, kwe moved to Chicago where he linked up with producer Anti to form Storm Before the Calm, a hip hop duo that led to studio and stage collaborations with legendary Chicago hip hop artist Bamski (Few Are Chosen). Later he would meet Nap Nat (aka <a href="https://jahseemusic.com/pages/about" target="blank" style={{ color: '#fbbf24' }}>Jahsee</a>) and  perform together as <i>The Afromerican Project</i>, before releasing their EP "A Future Now". After earning his stripes performing on the local spoken word and Hip Hop scenes, his songwriting and live sound evolved through session work with DJs, producers and musicians in Boston (Circadian Riddims), Chicago (Fix-A-Flat Productions) and Long Beach, CA (Collective I). 
                </p>
                <p>
                 His second album "Rocks" released in 2008 once he had relocated to Oakland, captures these collaboration years with songs like "<a href="https://www.youtube.com/watch?v=VXICfTsz1g8&list=RDVXICfTsz1g8&start_radio=1" target="_blank" rel="noreferrer" style={{ color: '#fbbf24' }}>Horizon</a>", "Who Am I?" (feat. DJ E Da Boss), "I Be Hip Hop" feat. Fada Dougou, "True Believing Warrior" feat. Big Samir and "Humble Ambitions" feat. J Ross Parelli.
                </p>
                <p>
                  Following the release of Rocks, kwe began touring from coast to coast, performing, producing and releasing podcasts and mixtapes under the Freedom Hour Radio banner, including the <a href="https://www.mixcloud.com/afrorootshop/farword-the-mixtape-vol-3-by-dj-akwerius-afro-roots-hop-mix-conscious-raggarootsdub/" target="blank" style={{ color: '#fbbf24' }}>Farword</a> series, as well as the <a href="https://open.spotify.com/album/33Xq95ue6jyK1ui6AMtyVW" target="blank" style={{ color: '#fbbf24' }}>Four Directions</a> mixtape/dubcast released by Circadian Riddims (2010). 
                </p>
                <p>
                  In December 2012, he relocated to Mount Shasta in Northern California to be closer to nature and focus on studio production. This intense shedding period lasted several years, and culminated in the release of two albums, "<a href="https://open.spotify.com/album/5JsUFkSWqcginOI85FXFrg" target="blank" style={{ color: '#fbbf24' }}>Astronomy</a>" (2019) and "<a href="https://aquarianproject.bandcamp.com/album/bright-side" target="_blank" rel="noreferrer"  style={{ color: '#fbbf24' }}>Bright Side</a>" (2021), both released on his own independent Music Is Healing imprint. The messages carried forth by the hypnotic, meditative and trance-inducing riddims rest on themes of brotherhood, devotion and praise with songs like "<a href="https://music.apple.com/us/album/his-name-feat-junior-toots-single/1615618294" target="_blank" rel="noreferrer"  style={{ color: '#fbbf24' }}>His Name</a>" feat. Junior Toots (mixed by Scientist) and "<a href="https://aquarianproject.bandcamp.com/track/christ-disciples-feat-nga-han" target="blank" style={{ color: '#fbbf24' }}>Christ and Disciples</a>" feat. Nga Han (co-prod. Roots Natty), as noteworthy collaborations. 
                  Upon returning to Boston in 2021, he returned to the stage for a string of shows that resulted in the 2023 release of the "<a href="#" target="blank" style={{ color: '#fbbf24' }}>Akwerian Project Live</a>" album (dub poetry/spoken soul jazz) and the single "<a href="https://open.spotify.com/album/3vNFWlX7hwk7DMQwOsNktH" target="blank" style={{ color: '#fbbf24' }}>Tell Dem</a>" produced by Dis N Dat. 
                </p>
                <p>
                  His upcoming album "Temple Music" continues in the same devotional stream and is dedicated to the loving memory of his parents, who transitioned a few months apart in 2024-25. It is a testament to the resilience of mind and spirit that comes when the heart learns to trust and obey in the design of the Creator for our lives, that His Will may be done. To be released under the Music Is Healing label, this devotional album aims to <i>do a new thing</i> in the cultural world of roots reggae today.
                </p>                
                <p>
                  He is also a frequent presence on radio and broadcast platforms. Akwerius has appeared multiple times on WBCA 102.9FM Boston, including the 2024 feature Songs of Praise with Ken Field and earlier studio sessions in 2023. His work has been showcased on WMBR 88.1FM and 88.9FM Cambridge, KALX 90.7FM Berkeley, HearticalFM (UK), and Cameroon Radio and Television (CRTV), where he has delivered both interviews and live in-studio performances. As a broadcaster and cultural worker himself, he has hosted his Freedom Hour Radio programs on KALX, WMBR and HearticalFM, as well as roundtable discussions featuring hip hop legends including Daddy-O (Stetsasonic), DJ Tony Tone (Cold Crush Brothers) and Dart Adams (hip hop journalist). Across these platforms, Akwerius’ voice—whether singing, chanting, or speaking—carries a message of healing, upliftment, and cultural remembrance to audiences worldwide.
                </p>
                <p>
                  Akwerius is currently producing "Journey to the Bright Side" - a documentary film retracing his quest in the making-of the Bright Side album. From Accra to Mount Shasta, the story explores themes of origin, identity, cultural heritage and what it means to be an African in the modern world. What does it mean to live in the Age of Akwerius? With the backdrop of a poet's reflective journey and stunning footage and interviews with singers and players of instruments of the Music Is Healing collective, an untold, powerful coming-of-age story emerges from West Africa to inspire generations to come.
                </p>
              </Box>
            </Grid>
          </Grid>
        </Box>
        </Container>
      </section>
      {/* END BIO SECTION */}

      {/* Connect Section */}
      <section
        id="connect"
        className="connect-section"
        style={{ marginTop: "4rem", position: "relative", zIndex: 1 }}
      >
        <div className="subscribe-overlay" style={{ padding: "2rem", textAlign: "center" }}>
          <br /><br />
          <h2 style={{ marginTop: "1rem" }}>Connect</h2>

          <form
            className="newsletter-form"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "1rem",
              marginTop: "1rem",
            }}
          >
            <input
              type="email"
              className="form-control"
              placeholder="Enter your email to receive the newsletter"
              style={{
                padding: "0.5rem 1rem",
                width: "100%",
                maxWidth: "320px",
                boxSizing: "border-box",
              }}
            />
            <button className="btn btn-warning" style={{ padding: "0.5rem 1.5rem" }}>
              Subscribe
            </button>
          </form>

          <div className="social-links" style={{ marginTop: "2rem" }}>
            <h4><strong>Follow</strong></h4>
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: "1rem 0",
                display: "flex",
                justifyContent: "center",
                gap: "1.5rem",
                flexWrap: "wrap",
              }}
            >
              <li>
                <a href="https://aquarianproject.bandcamp.com/" target="_blank" rel="noreferrer">
                  <img
                    src="https://wordsoundlife-berkeley-edu.apphost.ocf.berkeley.edu/images/bandcamp_logo.png"
                    alt="Bandcamp"
                    style={{ width: "32px", verticalAlign: "middle" }}
                  />
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/akwerius" target="_blank" rel="noreferrer">
                  <i className="fab fa-facebook fa-2x"></i>
                </a>
              </li>
              <li>
                <a href="http://instagram.com/musicishealingus" target="_blank" rel="noreferrer">
                  <i className="fab fa-instagram fa-2x"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCzFr7u6-hotJ32n1F9YG8zQ"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-youtube fa-2x"></i>
                </a>
              </li>
              <li>
                <a href="https://www.twitch.tv/musicishealingus" target="_blank" rel="noreferrer">
                  <i className="fab fa-twitch fa-2x"></i>
                </a>
              </li>
              <li>
                <a href="https://soundcloud.com/akwerius" target="_blank" rel="noreferrer">
                  <i className="fab fa-soundcloud fa-2x"></i>
                </a>
              </li>
              <li>
                <a href="https://www.mixcloud.com/musicishealingus" target="_blank" rel="noreferrer">
                  <i className="fab fa-mixcloud fa-2x"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <video autoPlay muted loop playsInline style={{ width: "100%", height: "auto", objectFit: "cover" }}>
          <source
            src="https://wordsoundlife-berkeley-edu.apphost.ocf.berkeley.edu/videos/Earth.mp4"
            type="video/mp4"
          />
        </video>
      </section>

      {/* Footer Player */}
      <FooterPlayer />
    </div>
  );
};

export default Landing;




// // src/Landing.js
// import React from 'react';
// import FooterPlayer from './components/FooterPlayer';
// import './Landing.css';

// const Landing = () => {
//   return (
//     <div className="landing-page">
//       {/* HERO SECTION */}
//       <header className="hero">
//         <div className="hero-content">
//           <h1>Akwerius</h1>
//           <p className="lead">Afro Roots Hop • Music Is Healing</p>
//           <div className="hero-buttons">
//             <a href="#album" className="btn btn-primary btn-lg">Latest Release</a>
//             <a href="#videos" className="btn btn-outline-light btn-lg">Watch</a>
//             <a href="http://musicishealing.us" target="_blank" rel="noreferrer" className="btn btn-danger btn-lg">Shop MIHU</a>
//           </div>
//         </div>
//       </header>

//       {/* LATEST RELEASE */}
//       <section id="album" className="section text-center">
//         <h2>Latest Release: Bright Side</h2>
//         <div className="container release-container">
//           <div className="album-cover">
//             <a href="https://aquarianproject.bandcamp.com/album/bright-side" target="_blank" rel="noreferrer">
//               <img
//                 src="https://wordsoundlife-berkeley-edu.apphost.ocf.berkeley.edu/images/BrightSide_Final.png"
//                 alt="Bright Side Album Cover"
//               />
//             </a>
//           </div>
//           <div className="album-info">
//             <p>
//               <strong>Arranged, Produced & Performed by Akwerius</strong><br />
//               Featuring Junior Toots, Nga Han, and more.
//             </p>
//             <a href="https://aquarianproject.bandcamp.com/album/bright-side" target="_blank" rel="noreferrer" className="btn btn-info">
//               Listen / Order CD
//             </a>
//           </div>
//         </div>
//       </section>

//       {/* VIDEOS */}
//       <section id="videos" className="section">
//         <h2>Music Videos</h2>
//         <div className="container video-grid">
//           <div className="video-item">
//             <iframe src="https://www.youtube.com/embed/aIhhljgDh_Y" allowFullScreen title="Hail His Majesty"></iframe>
//             <p>Hail His Majesty</p>
//           </div>
//           <div className="video-item">
//             <iframe src="https://www.youtube.com/embed/bif8VTI6VW0" allowFullScreen title="Bright Side"></iframe>
//             <p>Bright Side</p>
//           </div>
//           <div className="video-item">
//             <iframe src="https://www.youtube.com/embed/5oJp4Tw50-k" allowFullScreen title="Amen Ra"></iframe>
//             <p>Amen Ra</p>
//           </div>
//         </div>
//       </section>

//       {/* ABOUT */}
//       <section id="about" className="section about">
//         <h2>About</h2>
//         <div className="container about-container">
//           <div className="about-text">
//             <p>
//               kwe (Akwerius) is a poet, emcee, and deejay, creator of Afro Roots Hop and host of the <em>Freedom Hour</em> radio podcast.
//               His latest album <strong>Bright Side</strong> (2021) under the Music Is Healing imprint features collaborations with reggae artists Junior Toots and Nga Han.
//               He has toured across the U.S. and internationally, sharing devotional reggae and hip hop that uplifts and inspires.
//             </p>
//             <p>
//               <a href="mailto:info@akwerius.com">Bookings: info@akwerius.com</a>
//             </p>
//           </div>
//           <div className="about-image">
//             <img src="images/kwe-press4.jpg" alt="Akwerius Press Photo" />
//           </div>
//         </div>
//       </section>

//       {/* CONNECT */}
//       <section id="connect" className="section connect">
//         <h2>Connect</h2>
//         <div className="container connect-container">
//           <form className="newsletter-form">
//             <input type="email" className="form-control" placeholder="Enter your email to receive the newsletter" />
//             <button className="btn btn-warning ms-2">Subscribe</button>
//           </form>
//         </div>
//       </section>

//       {/* FOOTER WITH AUDIO PLAYER */}
//       <FooterPlayer />
//     </div>
//   );
// };

// export default Landing;
